/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddAppointmentNotes/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2AddAppointmentNote from 'DesignSystem/Svgs/Tysiav2AddAppointmentNote/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function AddAppointmentNotes({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/AdditionalOptions/Content/Options/AddAppointmentNotes"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let appointmentOverlayAddNotesValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'add_notes',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsBrandGreen = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.green'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let appointmentOverlayAddNotesValueData1 = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'add_notes',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let appointmentOverlayAddNotesValueData2 = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'add_notes',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<button
  data-testid="AddAppointmentNotes.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--pt-1-Z12VgRw': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-2-Z12VgRw': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-3-Z12VgRw': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-4-Z12VgRw': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--btlr-5-Z12VgRw': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--btrr-6-Z12VgRw': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bbrr-7-Z12VgRw': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bblr-8-Z12VgRw': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--g-11-Z12VgRw': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-9-Z12VgRw': appointmentOverlayAddNotesValueData ? dtColorsBrandGreen : dtColorsWhite,'--bc-10-Z12VgRw': appointmentOverlayAddNotesValueData ? dtColorsBrandGreen : dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2AddAppointmentNote
  viewPath={`${viewPath}/Tysiav2AddAppointmentNote`}
 fill2={appointmentOverlayAddNotesValueData1 ? dtColorsWhite : dtColorsNeutral300}
 data="appointment_overlay.add_notes"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="medium"
 color={appointmentOverlayAddNotesValueData2 ? dtColorsWhite : dtColorsNeutral500}
 marginLeft={dtSpaceXxs}
 text="Add appointment notes"
 data="appointment_overlay.add_notes"
/>
</button>
{children}
</React.Fragment>)
}